import { useMutation } from "@tanstack/react-query";

import { retryVerificationCode } from "~/patients/api/verificationCode";

export const useRetryVerificationCode = () => {
  return useMutation({
    mutationFn: retryVerificationCode,
  });
};
